import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

function aboutSlider() {

    const heroSlider = new Swiper(".about-slider", {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        effect: 'fade',
        speed: 700,
        fadeEffect: {
            crossFade: true
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    const nextBtns = document.querySelectorAll('.about-slider .next-slide-click');

    nextBtns.forEach(nextBtn => {
        nextBtn.addEventListener('click', () => {
            heroSlider.slideNext();
        })
    });

}

export default aboutSlider;

//module.exports = bannerSlider;